import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { UtilService, DialogService, NotificationService, TranslationService, DatagridService } from '../../shared/index';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileBenefitSearchParams } from '../shared/profile-benefit-search-params.model';
import { MembershipLevelBenefitSearchResult } from '../shared/membership-level-benefit-search-result.model';
import { MembershipLevelBenefit } from '../shared/membership-level-benefit.model';
import { BenefitService } from '../shared/benefit.service';
import { PagedResult } from '../../shared/model/paged-result.model';
import { ProfileBenefit } from '../shared/profile-benefit.model';
import { BenefitFlag } from '../shared/benefit-flag.model';
import { DataView as PrimeDataList } from 'primeng/dataview';
import { AsyncState } from '../../shared/model/index';
import { ProfileBenefitMgtComponent } from '../profile-benefit-mgt/profile-benefit-mgt.component';
import { LocalStorageService } from '../../shared/storage/local-storage.service';
import { AuthService } from '../../shared/auth/auth.service';
import { BenefitMgtComponentModel } from './benefit-mgt-component.model';
import { AuthUserInfo } from '../../shared/auth/auth-user-info.model';
//import moment from 'moment-es6';
import { MomentService } from '../../shared/moment/moment.service';

import { FeatureService } from '../../shared/feature/feature.service';
import { FeatureNameEnum } from '../../shared/feature/feature-name.enum';

const _benefitMgtComponentModelKey: string = 'benefitsMgtComponentModelOmg';

@Component({
  selector: 'wl-benefit-mgt',
  templateUrl: 'benefit-mgt.component.html',
  providers: [BenefitService],
  styleUrls: ['benefit-mgt.component.less'],
  standalone: false,
})
export class BenefitMgtComponent implements OnInit, AfterViewInit {
  @ViewChild('benefitsDataGrid', { static: false }) public _benefitsDataGrid: PrimeDataList;
  @ViewChild('profileBenefitComponent', { static: false }) public _profileBenefitComponent: ProfileBenefitMgtComponent;

  private _momentService: MomentService;
  public _utilService: UtilService;
  public _notifyService: NotificationService;
  public _translationService: TranslationService;
  public _benefitService: BenefitService;
  public _dialogService: DialogService;
  public _navigationService: NavigationService;
  public _selectedProfileId: number;
  // indicate whether or not to load data from the api
  public _fullLazyLoad: boolean;
  public _initComplete: boolean;

  public benMgtComonentModel: BenefitMgtComponentModel = new BenefitMgtComponentModel();
  public isSearching: boolean;
  public selectedAction: number = 0;
  public benefit: ProfileBenefit;
  public useDuesBillingDate: boolean;
  public benefitFlag: BenefitFlag;
  public hasEventBenefits: boolean;
  public loading: AsyncState;
  public showBenefitHelp: boolean;
  public featureRequested: boolean;
  public executing: boolean;
  public isSaving: boolean;
  public lg: boolean;

  public showAddBenefitModal = false;
  public showFlagBenefitModal = false;
  public showProfileBenefitModal = false;

  public constructor(
    utilService: UtilService,
    notifyService: NotificationService,
    translationService: TranslationService,
    benefitService: BenefitService,
    momentService: MomentService,
    dialogService: DialogService,
    navigationService: NavigationService,
    public _dataGridService: DatagridService,
    public _authService: AuthService,
    public _localStorageService: LocalStorageService,
    public _featureService: FeatureService
  ) {
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._translationService = translationService;
    this._benefitService = benefitService;
    this._dialogService = dialogService;
    this._navigationService = navigationService;
    this._momentService = momentService;

    this.loading = new AsyncState();
    this._fullLazyLoad = false;
    this.benMgtComonentModel = new BenefitMgtComponentModel();
    this.useDuesBillingDate = false;
    this.selectedAction = 0;
    this.benefit = new ProfileBenefit();
    this.benefitFlag = new BenefitFlag();
    this._initComplete = false;
    this.hasEventBenefits = true;
    this.showBenefitHelp = false;
    this.featureRequested = false;
  }

  ngOnInit() {
    this._featureService.has(FeatureNameEnum.BenefitManagement).then((data: boolean) => {
      this.hasEventBenefits = data;
    });

    this._benefitService.getBenefitTypes().then((data) => {
      this.showBenefitHelp = !data.length;
    });

    let pageEvent = { first: 0, rows: 10 };
    let componentModelRaw: string = this._localStorageService.getString(_benefitMgtComponentModelKey);
    if (componentModelRaw) {
      let tempComponentModel: BenefitMgtComponentModel = JSON.parse(componentModelRaw);
      let promise = this._authService.getUserInfo().then((x) => {
        if (tempComponentModel.userNum == x.wli_usernum && tempComponentModel.clientId == x.client_id) {
          this.benMgtComonentModel = tempComponentModel;
          this.benMgtComonentModel.benefits.Result.forEach(
            (x) =>
              (x.Selected =
                this.benMgtComonentModel.selectAllProfiles !== this.benMgtComonentModel.selectedProfiles.indexOf(x.ProfileId) > -1)
          );
          pageEvent.first = this.benMgtComonentModel.searchParams.PageNumber * this.benMgtComonentModel.searchParams.PageSize;
        } else {
          this.benMgtComonentModel.userNum = x.wli_usernum;
          this.benMgtComonentModel.clientId = x.client_id;
          this._fullLazyLoad = true;
        }
        this._initComplete = true;
        this._benefitsDataGrid.paginate(pageEvent);
      });
    } else {
      this._initComplete = true;
      this._fullLazyLoad = true;
      this._benefitsDataGrid.paginate(pageEvent);
    }
  }

  ngAfterViewInit() {
    this.searchBenefits();
  }

  public handleShowAdvancedSearch = (): void => {
    this.benMgtComonentModel.showAdvancedSearch = true;
  };

  public handleHideAdvancedSearch = (): void => {
    this.benMgtComonentModel.showAdvancedSearch = false;
  };

  public handleEditClick = (profileId: number): void => {
    this._navigationService.navigateToProfileBenefitsManagement(profileId);
  };

  public onSelectAllChange = (selectAll: boolean): void => {
    //reset the tracking array
    this.benMgtComonentModel.selectedProfiles = new Array<number>();

    for (let item of this.benMgtComonentModel.benefits.Result) {
      item.Selected = selectAll;
    }
    // save the model for later
    this._localStorageService.setString(_benefitMgtComponentModelKey, JSON.stringify(this.benMgtComonentModel));
  };

  public onProfileBenefitSelectedChange = (item: any): void => {
    // track it if it doesn't match the selectAllProfiles variable
    if (item.Selected != this.benMgtComonentModel.selectAllProfiles) {
      this.benMgtComonentModel.selectedProfiles.push(item.ProfileId);
    } else {
      let ind = this.benMgtComonentModel.selectedProfiles.findIndex(item.ProfileId);
      if (ind != null) this.benMgtComonentModel.selectedProfiles.splice(ind, 1);
    }
    // save the model for later
    this._localStorageService.setString(_benefitMgtComponentModelKey, JSON.stringify(this.benMgtComonentModel));
  };

  public editProfileClick = (profileId: number) => {
    this._profileBenefitComponent.setProfile(profileId);
    this.showProfileBenefitModal = true;
  };

  public searchBenefits = (): void => {
    (<any>this._benefitsDataGrid).first = 0;
    this.benMgtComonentModel.searchParams.PageNumber = 1;
    //reset the tracking array
    this.benMgtComonentModel.selectedProfiles = new Array<number>();
    this.benMgtComonentModel.selectAllProfiles = false;
    this.lazyLoadBenefits({ first: 0, rows: 10 });
  };

  public clearBenefits = (): void => {
    setTimeout(() => (this.benMgtComonentModel.searchParams = new ProfileBenefitSearchParams()));
    //reset the tracking array
    this.benMgtComonentModel.selectAllProfiles = false;
    this.benMgtComonentModel.selectedProfiles = new Array<number>();
    this.benMgtComonentModel.searchParams.AffCodes = [];
    this.benMgtComonentModel.benefits = new MembershipLevelBenefitSearchResult();
    this._localStorageService.removeItem(_benefitMgtComponentModelKey);
  };

  public lazyLoadBenefits = ($event: any): void => {
    // this is a hack. the page numbers don't work unless lazy load is on and setting the page numbers from the cache on init triggers this method.
    if (!this._initComplete) return;
    this._dataGridService.mapDatagridPagingToPagedSearch($event, this.benMgtComonentModel.searchParams);
    if ($event) {
      this.benMgtComonentModel.searchParams.PageNumber = $event.first / Math.max(1, $event.rows) + 1;
      this.benMgtComonentModel.searchParams.PageSize = 10;
    }
    if (!this._fullLazyLoad) {
      // we got the data from local storage. don't load data from the api.
      this._fullLazyLoad = true;
      return;
    }

    this.loading.busy = true;
    this.loading.success = false;
    this.isSearching = true;

    this._benefitService.searchProfileBenefits(this.benMgtComonentModel.searchParams).then(
      (data: PagedResult) => {
        this.benMgtComonentModel.benefits = data;
        this.isSearching = false;
        this.loading.busy = false;
        this.loading.success = true;
        this._localStorageService.setString(_benefitMgtComponentModelKey, JSON.stringify(this.benMgtComonentModel));
        this.benMgtComonentModel.benefits.Result.forEach(
          (x) =>
            (x.Selected =
              this.benMgtComonentModel.selectAllProfiles !== this.benMgtComonentModel.selectedProfiles.indexOf(x.ProfileId) > -1)
        );
      },
      () => {
        this.isSearching = false;
        this.loading.busy = false;
        this.loading.success = false;
      }
    );
  };

  public editBenefit = (benefit: MembershipLevelBenefit): void => {
    this._notifyService.info('Edit Benefit Here');
  };

  public executeAction = () => {
    if (this.benMgtComonentModel.selectAllProfiles || this.benMgtComonentModel.selectedProfiles.length) {
      if (this.selectedAction == 1) {
        this.benefit = new ProfileBenefit();
        this.benefit.ExpirationDate = this._momentService.getMomentByDate(new Date()).add('y', 1).toDate();
        this.showAddBenefitModal = true;
      }
      if (this.selectedAction == 2) {
        this.benefitFlag = new BenefitFlag();
        this.showFlagBenefitModal = true;
      }
      if (this.selectedAction == 3) {
        this.renewBenefits();
      }
    } else {
      let confirmMessage = this._translationService.getInstant('benefits.benefit-mgt.select-profiles-notification');
      this._dialogService.info(confirmMessage);
    }
  };

  public saveBenefits = () => {
    this._benefitService
      .massCreateProfileBenefits(
        this.benefit,
        this.benMgtComonentModel.selectedProfiles,
        this.useDuesBillingDate,
        this.benMgtComonentModel.selectAllProfiles,
        this.benMgtComonentModel.searchParams
      )
      .then((data) => {
        this._notifyService.success(this._translationService.getInstantTitlecase('common.saved'));
      });
    this.showAddBenefitModal = false;
  };

  public flagBenefits = () => {
    this.benefitFlag.ProfileIds = this.benMgtComonentModel.selectedProfiles;

    this._benefitService
      .massFlagProfileBenefits(this.benefitFlag, this.benMgtComonentModel.selectAllProfiles, this.benMgtComonentModel.searchParams)
      .then((data) => {
        this._notifyService.success(this._translationService.getInstantTitlecase('common.saved'));
      });
    this.showFlagBenefitModal = false;
  };

  public renewBenefits = () => {
    let confirmMessage = this._translationService.getInstant('benefits.benefit-mgt.renew-all-benefits-confirmation');

    this._dialogService.confirmYesNo(
      confirmMessage,
      () => {
        this._benefitService
          .massRenewProfileBenefits(
            this.benMgtComonentModel.selectedProfiles,
            this.benMgtComonentModel.selectAllProfiles,
            this.benMgtComonentModel.searchParams
          )
          .then(() => {
            this._notifyService.success(this._translationService.getInstantTitlecase('common.saved'));
          });
      },
      () => {}
    );
  };

  public requestFeature = () => {
    this.featureRequested = true;
    this._featureService
      .requestFeature(FeatureNameEnum.BenefitManagement)
      .then((x) => {
        this._notifyService.success(this._translationService.getInstant('common.phrases.request-license-success'));
      })
      .catch((x) => {
        this.featureRequested = false;
        this._notifyService.warn(this._translationService.getInstant('common.phrases.request-license-failure'));
      });
  };
}
